import _ from 'lodash'
import type {ComponentExportStructure} from '@wix/document-services-types'
import type {DecorationSingleComponentPluginFunction} from '../../types'
import {linkReferenceUtil} from '../../utils/linkReference'
import {SUPPORTED_DATA_TYPES} from './constants'

export const pack: DecorationSingleComponentPluginFunction = (component: ComponentExportStructure) => {
    if (!component.data) {
        return
    }

    const {type, link} = component.data
    if (!link || !type || !SUPPORTED_DATA_TYPES.has(type)) {
        return
    }

    const attributes = linkReferenceUtil.pack(link)
    if (!attributes) {
        return
    }

    delete component.data.link
    _.assign(component, attributes)
}
